// import React, { useState } from "react";
// import Navb from "../../components/navbar/Navb";
// import Footer from "../../components/footer/Footer";
// import OurTeam from "../../components/ourTeam/OurTeam";
// import Img1 from "./aboutImg1.png";
// import Img2 from "./img2.png";
// import Icon1 from "./Icon1.png";
// import Icon2 from "./Icon2.png";
// import Icon3 from "./Icon3.png";
// import Icon4 from "./Icon4.png";
// import Container from "react-bootstrap/Container";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import "./about.css";

// const About = () => {
//   const [displayText, setDisplayText] = useState(
//     "Transforming workplaces with tailored HR strategies, we aspire to create environments that thrive on excellence, inclusivity, and unparalleled employee satisfaction."
//   );
//   const [activeButton, setActiveButton] = useState("Vision");

//   const handleButtonClick = (text) => {
//     setActiveButton(text);
//     switch (text) {
//       case "Vision":
//         setDisplayText(
//           "Our vision is to bring a smile to every mother's face, every investor’s face, and top management by ensuring success in society, markets, and competition. We aim to provide equitable employment opportunities for rural Indians, LGBTQ+, and all marginalized sections, ensuring fairness and strength in the economy."
//         );
//         break;
//       case "Mission":
//         setDisplayText(
//           "Our mission is to empower rural youth and marginalized communities by bridging the gap between corporates, communities, and employability. We aim to eradicate the fear of entering the corporate world, upskill fresh talent, and diversify workplaces by setting high standards."
//         );
//         break;
//       case "Value":
//         setDisplayText(
//           "Our core value is deliverance, not false commitments. This value is reflected in our client satisfaction and the impact we create. We provide effective business solutions to foster a strong brand equity ecosystem."
//         );
//         break;
//       default:
//         setDisplayText("");
//     }

//   };
//   return (
//     <>
//       <Navb />

//       <Container
//         className="aboutHeader  row p-0 align-items-center  justify-content-center"
//         style={{ width: "100%", padding: "0px", margin: "2rem auto 3rem auto" }}
//       >
//         <div
//           className="aboutimgHeader col-lg-6 col-md-10 col-sm-12"
//           style={{ overflow: "hidden", padding: "0px", borderRadius: "18px" }}
//         >
//           <img src={Img1} alt="Img1" />
//         </div>

//         <div className="aboutHeaderText1 col-lg-6 col-md-10 col-md-11 text-center text-lg-start px-4 ">
//           <div
//             className="Heading43 mt-5 mt-lg-0 mb-3"
//             style={{ "font-size": "clamp(1.5rem, 1.5vw + 1rem, 2.6875rem)" }}
//           >
//             Igniting Careers. <br /> Empowering Organizations.
//           </div>
//           <p className="aboutHeaderP1 mb-3">
//             For over 17 years, UADAYA Solutions has connected talent with top
//             companies in construction, manufacturing, and more. Success here is
//             about empowering individuals to grow.
//           </p>
//           <p className="aboutHeaderP1 mb-3">
//             "Our People Are Everything." Whether you're seeking meaningful
//             careers or skilled employees, UADAYA Solutions delivers excellence
//             and lasting partnerships.
//           </p>

//           {/* <Bluebutton Text="Get in Touch" Link="contact" /> */}
//         </div>
//       </Container>
//       <div className="aboutTeam Heading43">Our Team</div>
//       <div className="team">
//   <div className="aboutTeamBundle">
//     <img src={Img2} alt="Img1" />
//     <div className="aboutTeamtext">Aparna Sharma</div>
//     <div className="aboutTeamtext1">Chief Operating Officer</div>
//   </div>
//   <div className="aboutTeamBundle">
//     <img src={Img2} alt="Img2" />
//     <div className="aboutTeamtext">Rajesh Menon</div>
//     <div className="aboutTeamtext1">Head of Human Resources</div>
//   </div>
//   <div className="aboutTeamBundle">
//     <img src={Img2} alt="Img3" />
//     <div className="aboutTeamtext">Suhasini Rao</div>
//     <div className="aboutTeamtext1">Chief Technology Officer</div>
//   </div>
//   <div className="aboutTeamBundle">
//     <img src={Img2} alt="Img4" />
//     <div className="aboutTeamtext">Vivek Gupta</div>
//     <div className="aboutTeamtext1">Director of Sales and Marketing</div>
//   </div>
//   <div className="aboutTeamBundle">
//     <img src={Img2} alt="Img5" />
//     <div className="aboutTeamtext">Meera Kapoor</div>
//     <div className="aboutTeamtext1">Lead HR Consultant</div>
//   </div>
// </div>

//       <div className="aboutTeam Heading43">Our Strength</div>{" "}
//       <div className="ourStrength">
//         {" "}
//         Strategic HR Innovations: Elevate Your Workplace Dynamics{" "}
//       </div>{" "}
//       <div className="container mt-5" style={{"margin-bottom": "7rem"}}>
//         {" "}
//         <div className="row g-lg-2 g-md-4 g-sm-4 g-4 justify-content-center mb-5">
//           {" "}
//           <div className="col-lg-3 col-md-6 col-sm-10 col-10 d-flex justify-content-center">
//             {" "}
//             <OurTeam
//               Icon={Icon1}
//               Heading="Expert HR Solutions"
//               Text="Our team’s deep expertise in human resources and workforce management ensures that we deliver tailored solutions designed to meet the evolving needs of your business."
//             />{" "}
//           </div>{" "}
//           <div className="col-lg-3 col-md-6 col-sm-10 col-10 d-flex justify-content-center">
//             {" "}
//             <OurTeam
//               Icon={Icon2}
//               Heading="Cross-Disciplinary Experience"
//               Text="With experience across HR, technology, sales, and marketing, our professionals bring a well-rounded perspective to solving complex business challenges."
//             />{" "}
//           </div>{" "}
//           <div className="col-lg-3 col-md-6 col-sm-10 col-10 d-flex justify-content-center">
//             {" "}
//             <OurTeam
//               Icon={Icon3}
//               Heading="Dedicated Support"
//               Text="Our strong relationships with industry leaders, combined with our commitment to understanding your unique needs, make us the ideal partner for your workforce strategy."
//             />{" "}
//           </div>{" "}
//           <div className="col-lg-3 col-md-6 col-sm-10 col-10 d-flex justify-content-center">
//             {" "}
//             <OurTeam
//               Icon={Icon4}
//               Heading="Innovative Approaches"
//               Text="We stay ahead of industry trends to bring forward-thinking strategies and innovative HR solutions that drive performance and growth for your organization."
//             />{" "}
//           </div>{" "}
//         </div>{" "}
//       </div>
//       <div className="container my-5">
//         <div className=" aboutVision row align-items-center justify-content-center">
//           <div className="col-lg-3 col-md-4 col-sm-10 col-10">
//             <div className="aboutVisionTopics Heading43">
//               <button
//                 className={activeButton === "Vision" ? "active" : ""}
//                 onClick={() => handleButtonClick("Vision")}
//               >
//                 Vision
//               </button>
//               <button
//                 className={activeButton === "Mission" ? "active" : ""}
//                 onClick={() => handleButtonClick("Mission")}
//               >
//                 Mission
//               </button>
//               <button
//                 className={activeButton === "Value" ? "active" : ""}
//                 onClick={() => handleButtonClick("Value")}
//               >
//                 Value
//               </button>
//             </div>
//           </div>
//           <div className="col-lg-8 col-md-7 col-sm-10 col-10">
//             {" "}
//             <div className="aboutVisionP">{displayText}</div>
//           </div>
//         </div>
//       </div>
//       {/* <div className="aboutVision">
//         <div className="aboutVisionTopics Heading43">
//           <button
//             className={activeButton === "Vision" ? "active" : ""}
//             onClick={() => handleButtonClick("Vision")}
//           >
//             Vision
//           </button>
//           <button
//             className={activeButton === "Mission" ? "active" : ""}
//             onClick={() => handleButtonClick("Mission")}
//           >
//             Mission
//           </button>
//           <button
//             className={activeButton === "Value" ? "active" : ""}
//             onClick={() => handleButtonClick("Value")}
//           >
//             Value
//           </button>
//         </div>
//         <div className="aboutVisionP">{displayText}</div>
//       </div> */}
//       <div className="aboutOffices Heading43">Our Offices</div>
//       <div className="aboutOfficesItems">
//         <div className="aboutOfficesItem">
//           <div className=" Heading43" style={{ padding: "2rem 0rem 1rem" }}>
//             Bhubneshwar
//           </div>
//           <div className="aboutOfficesAddress">
//             1234 Elm Street, Bhubaneswar, Odisha, 751010, India.
//           </div>
//           {/* <div className="aboutOfficesAddress">View On Map</div> */}
//           <div className="aboutOfficesAddress">T: +91 7785412556</div>
//         </div>
//         <div className="aboutOfficesItem">
//           <div className=" Heading43" style={{ padding: "2rem 0rem 1rem" }}>
//             Gurugram
//           </div>
//           <div className="aboutOfficesAddress">
//             1234 Elm Street, Bhubaneswar, Odisha, 751010, India.
//           </div>
//           {/* <div className="aboutOfficesAddress">View On Map</div> */}
//           <div className="aboutOfficesAddress">T: +91 7785412556</div>
//         </div>
//       </div>
//       {/* Heading43 */}
//       <Footer />
//     </>
//   );
// };

// export default About;
import React, { useState } from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import OurTeam from "../../components/ourTeam/OurTeam";
import Img1 from "../services/img1.png";
// import Img1 from "./aboutImg1.png";
import Img11 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import Icon1 from "./Icon1.png";
import Icon2 from "./Icon2.png";
import Icon3 from "./Icon3.png";
import Aboutimgtop from "../home/homeimg7.png";
import AboutHero from "./AboutHero.png";
import AboutTopImg from "./AboutTopImg.png";
import Clients from "./clients.png";
import Icon4 from "./Icon4.png";
import Container from "react-bootstrap/Container";
import "./about.css";

const About = () => {
  const [displayText, setDisplayText] = useState(
    "Transforming workplaces with tailored HR strategies, we aspire to create environments that thrive on excellence, inclusivity, and unparalleled employee satisfaction."
  );
  const [activeButton, setActiveButton] = useState("Vision");

  const handleButtonClick = (text) => {
    setActiveButton(text);
    switch (text) {
      case "Vision":
        setDisplayText(
          "Our vision is to bring a smile to every mother's face, every investor’s face, and top management by ensuring success in society, markets, and competition. We aim to provide equitable employment opportunities for rural Indians, LGBTQ+, and all marginalized sections, ensuring fairness and strength in the economy."
        );
        break;
      case "Mission":
        setDisplayText(
          "Our mission is to empower rural youth and marginalized communities by bridging the gap between corporates, communities, and employability. We aim to eradicate the fear of entering the corporate world, upskill fresh talent, and diversify workplaces by setting high standards."
        );
        break;
      case "Value":
        setDisplayText(
          "Our core value is deliverance, not false commitments. This value is reflected in our client satisfaction and the impact we create. We provide effective business solutions to foster a strong brand equity ecosystem."
        );
        break;
      default:
        setDisplayText("");
    }
  };

  return (
    <>
      <Navb />
      {/* <Container
        className="aboutHeader row p-0 align-items-center justify-content-center"
        style={{ width: "100%", margin: "2rem auto 3rem auto" }}
      >
        <div
          className="aboutimgHeader col-lg-6 col-md-10 col-sm-12"
          style={{ overflow: "hidden", padding: "0px", borderRadius: "18px" }}
        >
          <img src={Img1} alt="Img1" />
        </div>

        <div className="aboutHeaderText1 col-lg-6 col-md-10 text-center text-lg-start px-4">
          <div
            className="Heading43 mt-5 mt-lg-0 mb-3"
            style={{ fontSize: "clamp(1.5rem, 1.5vw + 1rem, 2.6875rem)" }}
          >
            Igniting Careers. <br /> Empowering Organizations.
          </div>
          <p className="aboutHeaderP1 mb-3">
            For over 17 years, UADAYA Solutions has connected talent with top
            companies in construction, manufacturing, and more. Success here is
            about empowering individuals to grow.
          </p>
          <p className="aboutHeaderP1 mb-3">
            "Our People Are Everything." Whether you're seeking meaningful
            careers or skilled employees, UADAYA Solutions delivers excellence
            and lasting partnerships.
          </p>
        </div>
      </Container>
       */}
      <div className="container my-5">
        <div className="row align-items-center">
          {/* Left Illustration Section */}
          <div className="col-md-7 text-start mb-4 mb-md-0">
            <div className="d-flex gap-3 pb-2">
              <span
                style={{ "font-weight": "600", color: "var(--primary-color)" }}
              >
                About Us
              </span>
            </div>
            <div
              className="Heading43 mt-2 mt-lg-0 mb-4"
              style={{ "line-height": "55px", color: "var(--primary-color)" }}
            >
              Igniting Careers Empowering Organizations.
            </div>
            <div className="ms-5 pb-3">
              <div className="fw-bold">Talent Acquisition</div>
              <div>
                For over 17 years, UADAYA Solutions has connected talent with
                top companies in construction, manufacturing, and more. Success
                here is about empowering individuals to grow.
              </div>
            </div>
            <div className="ms-5">
              <div className="fw-bold">Partnership Excellence</div>
              <div>
                "Our People Are Everything." Whether you're seeking meaningful
                careers or skilled employees, UADAYA Solutions delivers
                excellence and lasting partnerships.
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="illustration-container">
              <img
                src={AboutTopImg}
                alt="AboutTopImg"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container my-5">
        <div className="row align-items-center">
          {/* Left Illustration Section */}
          <div className="col-md-6 text-center mb-4 mb-md-0">
            <div className="illustration-container">
              <img src={AboutHero} alt="AboutHero" style={{ width: "100%" }} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex gap-3 pb-2">
              <span
                style={{ "font-weight": "600", color: "var(--primary-color)" }}
              >
                Why Choose Us
              </span>
            </div>
            <div
              className="Heading43 mt-2 mt-lg-0 mb-4"
              style={{ "line-height": "55px", color: "var(--primary-color)" }}
            >
              Experiencing Traditions Cultural Immersion
            </div>
            <div className="ms-5 pb-3">
              <div className="fw-bold">Marketing Services</div>
              <div>
                Transforming ideas into powerful campaigns that deliver results.
              </div>
            </div>
            <div className="ms-5">
              <div className="fw-bold">Consulting Services</div>
              <div>
                Unlocking potential with tailored strategies for success.
              </div>
            </div>
          </div>
        </div>
      </div>
      <Container className="aboutContent my-5">
        <div className="aboutJourney">
          <div className="Heading43 mb-4 text-center">Our Journey</div>
          <p className="aboutHeaderP1">
            Established in 2007, UADAYA Solutions' passion to match the right
            people to the right job has helped us amass over a decade of
            successful stories in the human resource business.
            {/* </p>
          <p className="aboutHeaderP1"> */}
            Each client and candidate is like an extended family member to us.
            And like family, we understand and anticipate your needs, matching
            the right candidates to the right clients.
          </p>
          <p className="aboutHeaderP1">
            Our professionalism, coupled with a strong personal touch, enhances
            the probability of success at every step. Our goal is to create a
            long-lasting client-candidate relationship, translating into long
            term winning strategies and exponential growth for both parties.
          </p>
          <p className="aboutHeaderP1">
            At UADAYA Solutions, we understand that the overall chemistry
            between the candidate and the existing management is paramount in
            ensuring a good match.
          </p>
          <p className="aboutHeaderP1">
            To ensure success, we believe in hiring people with the right values
            and specialized experience. If you wish to find out more or engage
            our manpower solution, please do not hesitate to contact us. We look
            forward to serving you in our professional journey.
          </p>
        </div>
      </Container>
      <Container className="teamContainer">
        <div className="aboutTeam Heading43">Our Team</div>
        <div className="team">
          <div className="aboutTeamBundle">
            <img src={Img11} alt="Img1" />
            <div className="aboutTeamtext my-2">BISWA RANJAN DAS</div>
            <div className="aboutTeamtext1 mb-2">Managing Director</div>
          </div>
          <div className="aboutTeamBundle">
            <img src={Img2} alt="Img2" />
            <div className="aboutTeamtext my-2">MINAKHI PRADHAN</div>
            <div className="aboutTeamtext1 mb-2">Director</div>
          </div>
          <div className="aboutTeamBundle">
            <img src={Img3} alt="Img3" />
            <div className="aboutTeamtext my-2">KALPANA DAS</div>
            <div className="aboutTeamtext1">Director</div>
          </div>
        </div>
      </Container>
      <Container
        className="aboutDesign py-5 mt-5"
        style={{
          backgroundColor: "#E45220",
          width: "70%",
          "border-radius": "20px 20px 0px 0px",
        }}
      >
        <div className="container text-center text-white">
          <h2
            className="mb-4"
            style={{ width: "max-content", margin: "1px auto" }}
          >
            SUCCESS STORY
          </h2>
          <div className="row g-4">
            {Array.from({ length: 4 }).map((_, index) => (
              <div
                key={index}
                className="col-md-6 d-flex flex-column flex-md-row align-items-md-start"
              >
                <div
                  className="me-md-3 mb-2 mb-md-0"
                  style={{
                    flex: "0 0 auto",
                    fontSize: "2.5rem",
                    fontWeight: "bold",
                  }}
                >
                  {`0${index + 1}`}
                </div>
                <div>
                  <p className="mb-0 text-start">
                    {index === 0 &&
                      "UADAYA Solutions has successfully connected skilled professionals with top construction companies for over 17 years. By matching talent to the right projects, we’ve built strong, long-lasting partnerships that drive industry growth."}
                    {index === 1 &&
                      "Over the years, UADAYA Solutions has helped thousands of individuals find meaningful careers. We focus on personal growth and match professionals with opportunities that align with their skills and aspirations."}
                    {index === 2 &&
                      "UADAYA Solutions has consistently helped businesses grow by providing top-tier talent. Our approach ensures that companies gain the right professionals who contribute to their success and create a lasting impact."}
                    {index === 3 &&
                      "UADAYA Solutions excels in building strong, skilled teams. We’ve helped numerous companies in various industries find the right talent, fostering a culture of innovation and success that leads to growth and stability."}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
      <Container
        className="aboutDesign1 py-5 rounded-5"
        style={{ backgroundColor: "var(--primary-color)" }}
      >
        <div className="text-center text-white">
          <div className="d-flex justify-content-center gap-3 pb-2">
            <img src={Aboutimgtop} alt="Homeimg4" />
            <span style={{ fontWeight: "600", color: "white" }}>
              Process Overview
            </span>
          </div>
          <div
            className="Heading43 mt-2 mt-lg-0 mb-4"
            style={{ lineHeight: "55px" }}
          >
            Igniting Careers Empowering <br /> Organizations.
          </div>

          <div className="row justify-content-center gap-4">
            <div
              className="col-12 col-md-3 mb-5 p-4 d-flex flex-column align-items-center align-items-md-start"
              style={{
                backgroundColor: "white",
                color: "black",
                borderRadius: "1rem",
              }}
            >
              <div className="d-flex justify-content-center align-items-center">
                <span className="styled-number">01</span>
              </div>
              <div
                className="aboutTeamtext my-2"
                style={{
                  color: "#E45220",
                }}
              >
                MISSION
              </div>
              <div>
                <p className="mb-0 text-start">
                  We connect exceptional talent with forward-thinking
                  organizations, fostering growth, innovation, and success. We
                  are committed to delivering personalized recruitment
                  solutions, building lasting relationships, and empowering
                  individuals to achieve their career aspirations while helping
                  businesses thrive with the right people in the right roles.
                </p>
              </div>
            </div>

            <div
              className="translateY-md col-12 col-md-3 p-4 mb-5 d-flex flex-column align-items-center align-items-md-start"
              style={{
                backgroundColor: "white",
                color: "black",
                borderRadius: "1rem",
                // transform: "translateY(12%)",
              }}
            >
              <div className="d-flex justify-content-center align-items-center">
                <span className="styled-number">02</span>
              </div>
              <div
                className="aboutTeamtext my-2"
                style={{
                  color: "#E45220",
                }}
              >
                VISION
              </div>
              <div>
                <p className="mb-0 text-start">
                  Our vision to be trusted global leader in talent acquisition,
                  recognized for redefining recruitment standards through
                  innovation, integrity, and excellence. We envision a world
                  where every individual finds fulfillment in their professional
                  journey, and thrives with the right talent driving their
                  success.
                </p>
              </div>
            </div>

            <div
              className="col-12 col-md-3 mb-5 p-4 d-flex flex-column align-items-center align-items-md-start"
              style={{
                backgroundColor: "white",
                color: "black",
                borderRadius: "1rem",
              }}
            >
              <div className="d-flex justify-content-center align-items-center">
                <span className="styled-number">03</span>
              </div>
              <div
                className="aboutTeamtext my-2"
                style={{
                  color: "#E45220",
                }}
              >
                VALUE
              </div>
              <div>
                <p className="mb-0 text-start">
                  We are driven by a commitment to integrity, excellence, and
                  collaboration. Our core values focus on empowering individuals
                  and organizations to achieve their full potential. We foster
                  innovation, uphold accountability, and build lasting
                  relationships by providing exceptional service. At UADAYA
                  Solutions, we believe in creating an environment where trust,
                  mutual respect, and continuous growth are at the heart of
                  everything we do.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
      {/* <div className="aboutTeam Heading43">Our Strength</div>{" "}
      <div className="ourStrength">
        {" "}
        Strategic HR Innovations: Elevate Your Workplace Dynamics{" "}
      </div>{" "}
      <div className="container mt-5" style={{ "margin-bottom": "7rem" }}>
        {" "}
        <div className="row g-lg-2 g-md-4 g-sm-4 g-4 justify-content-center mb-5">
          {" "}
          <div className="col-lg-3 col-md-6 col-sm-10 col-10 d-flex justify-content-center">
            {" "}
            <OurTeam
              Icon={Icon1}
              Heading="Expert HR Solutions"
              Text="Our team’s deep expertise in human resources and workforce management ensures that we deliver tailored solutions designed to meet the evolving needs of your business."
            />{" "}
          </div>{" "}
          <div className="col-lg-3 col-md-6 col-sm-10 col-10 d-flex justify-content-center">
            {" "}
            <OurTeam
              Icon={Icon2}
              Heading="Cross-Disciplinary Experience"
              Text="With experience across HR, technology, sales, and marketing, our professionals bring a well-rounded perspective to solving complex business challenges."
            />{" "}
          </div>{" "}
          <div className="col-lg-3 col-md-6 col-sm-10 col-10 d-flex justify-content-center">
            {" "}
            <OurTeam
              Icon={Icon3}
              Heading="Dedicated Support"
              Text="Our strong relationships with industry leaders, combined with our commitment to understanding your unique needs, make us the ideal partner for your workforce strategy."
            />{" "}
          </div>{" "}
          <div className="col-lg-3 col-md-6 col-sm-10 col-10 d-flex justify-content-center">
            {" "}
            <OurTeam
              Icon={Icon4}
              Heading="Innovative Approaches"
              Text="We stay ahead of industry trends to bring forward-thinking strategies and innovative HR solutions that drive performance and growth for your organization."
            />{" "}
          </div>{" "}
        </div>{" "}
      </div>
      <div className="container my-5">
        <div className=" aboutVision row align-items-center justify-content-center">
          <div className="col-lg-3 col-md-4 col-sm-10 col-10">
            <div className="aboutVisionTopics Heading43">
              <button
                className={activeButton === "Vision" ? "active" : ""}
                onClick={() => handleButtonClick("Vision")}
              >
                Vision
              </button>
              <button
                className={activeButton === "Mission" ? "active" : ""}
                onClick={() => handleButtonClick("Mission")}
              >
                Mission
              </button>
              <button
                className={activeButton === "Value" ? "active" : ""}
                onClick={() => handleButtonClick("Value")}
              >
                Value
              </button>
            </div>
          </div>
          <div className="col-lg-8 col-md-7 col-sm-10 col-10">
            {" "}
            <div className="aboutVisionP">{displayText}</div>
          </div>
        </div>
      </div> */}
      {/* <div className="aboutVision">
        <div className="aboutVisionTopics Heading43">
          <button
            className={activeButton === "Vision" ? "active" : ""}
            onClick={() => handleButtonClick("Vision")}
          >
            Vision
          </button>
          <button
            className={activeButton === "Mission" ? "active" : ""}
            onClick={() => handleButtonClick("Mission")}
          >
            Mission
          </button>
          <button
            className={activeButton === "Value" ? "active" : ""}
            onClick={() => handleButtonClick("Value")}
          >
            Value
          </button>
        </div>
        <div className="aboutVisionP">{displayText}</div>
      </div> */}
      {/* <div className="aboutOffices Heading43">Our Offices</div>
      <div className="aboutOfficesItems">
        <div className="aboutOfficesItem">
          <div className=" Heading43" style={{ padding: "2rem 0rem 1rem" }}>
            Bhubneshwar
          </div>
          <div className="aboutOfficesAddress">
            1234 Elm Street, Bhubaneswar, Odisha, 751010, India.
          </div>
         
          <div className="aboutOfficesAddress">T: +91 7785412556</div>
        </div>
        <div className="aboutOfficesItem">
          <div className=" Heading43" style={{ padding: "2rem 0rem 1rem" }}>
            Gurugram
          </div>
          <div className="aboutOfficesAddress">
            1234 Elm Street, Bhubaneswar, Odisha, 751010, India.
          </div>
         
          <div className="aboutOfficesAddress">T: +91 7785412556</div>
        </div>
      </div> */}
      {/* Additional Components like Our Team, Vision, Mission */}
      <Footer />
    </>
  );
};

export default About;
